import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {MyPriceApprovalModeEnum} from '../../../enums/my-price-approval-mode.enum';
import {MyDialogDataModel} from '../../../models/my-dialog-data.model';
import {Subscription} from 'rxjs';
import {EditModalService} from '../../../services/edit-modal.service';
import {EditModalCustomPriceTableService} from '../../../services/edit-modal-custom-price-table.service';
import {ModalVisibilityService} from '../../../services/modal-visibility.service';
import {MyNotDeviceRequestContainerModel} from '../../../models/my-not-device-request-container.model';
import {RPriceInfoModel} from '../../../models/r-price-info.model';
import {DecimalPipe} from '@angular/common';
import {RPriceInfoModalComponent} from '../r-price-info-modal/r-price-info-modal.component';
import {ModalDynamicV3Service} from '../../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';

@Component({
    selector: 'app-additional-items-table-viewer',
    templateUrl: './additional-items-table-viewer.component.html',
    styleUrls: ['./additional-items-table-viewer.component.scss']
})
export class AdditionalItemsTableViewerComponent extends EditModalSectionBaseComponent implements OnInit, OnDestroy {


    @Input() usePriceApprovalMode = MyPriceApprovalModeEnum.DISABLED;
    // @Input() tableId: MyContainersTableIdEnum;
    @Input() public tableItems: MyNotDeviceRequestContainerModel[];
    @Input() title: string;
    @Input() infoIconText: string;
    public model: MyDialogDataModel;

    private modalVisibilitySub: Subscription;
    private rPriceInfoModalDialogRef: any;

    constructor(
        public editModalService: EditModalService,
        public editModalCustomPriceTableService: EditModalCustomPriceTableService,
        public modalVisibilityService: ModalVisibilityService,
        private modalDynamicV3Service: ModalDynamicV3Service
    ) {
        super(editModalService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.model = this.editModalService.getDialogModel();
    }

    public isInternalUser() {
        return false;
    }



    private openRPricesInfoModal(rPriceInfos: RPriceInfoModel[], anchor: any) {

        if (!this.isActivePriceApprovalMode()) {
            return;
        }

        this.modalVisibilityService.announceCloseEditDialogModalsRequest('waranty openRPricesInfoModal');


        const deltaX = -92;
        const deltaY = 0;


        const msgRows = rPriceInfos.map(rPriceInfo => {
            const formattedRPrice = new DecimalPipe('de-DE').transform(+rPriceInfo.rPrice, '1.2-2');
            return formattedRPrice + ' € (' + rPriceInfo.rPriceIdentifier + ')';
        });


        // helps avoid to display dialog out of the screen
        const expectedDialogHeight = (rPriceInfos.length * 28) + 12;
        const marginBottom = 10;

        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;

        let top = Math.floor(+anchor.getBoundingClientRect().top) + deltaY;

        if (windowHeight - expectedDialogHeight < top) {
            top = windowHeight - (expectedDialogHeight + marginBottom);
        }

        const right = Math.floor(windowWidth - anchor.getBoundingClientRect().right) - deltaX;

        this.rPriceInfoModalDialogRef = this.modalDynamicV3Service
            .open(RPriceInfoModalComponent, {
                model: {
                    msgRows: msgRows,
                    top: top + 'px',
                    right: right + 'px',
                    showCloseBtn: false,
                    minHeight: 40,
                }
            });


        this.modalVisibilitySub = this.modalVisibilityService.closeProjectListPageModalsRequestAnnounced$.subscribe(_ => {

            if (this.rPriceInfoModalDialogRef) {
                this.rPriceInfoModalDialogRef.close();
                this.modalVisibilitySub.unsubscribe();
                this.rPriceInfoModalDialogRef = undefined;
                this.modalVisibilitySub = undefined;
            }
        });

    }

    public isActivePriceApprovalMode() {
        return this.usePriceApprovalMode === MyPriceApprovalModeEnum.ACTIVE;
    }


    public ngOnDestroy(): void {
        if (this.modalVisibilitySub) {
            this.modalVisibilitySub.unsubscribe();
        }
    }

    public closeRPricesInfoModal() {
        if (this.rPriceInfoModalDialogRef) {
            this.rPriceInfoModalDialogRef.close();
            this.rPriceInfoModalDialogRef = undefined;
        }
    }

    public isSelectedPriceTypeEqualOtherPrice(priceLevel: string): boolean {
        return this.editModalCustomPriceTableService.isSelectedPriceTypeEqualOtherPrice(priceLevel);
    }

    public getExtendedRPriceChoices(priceInfos: RPriceInfoModel[]): string[] {
        return this.editModalCustomPriceTableService.getExtendedRPriceChoices(priceInfos);
    }

    public getExtendedRPriceValues(priceInfos: RPriceInfoModel[]): string[] {
        return this.editModalCustomPriceTableService.getExtendedRPriceValues(priceInfos);
    }

    public priceNoteShouldBeVisible(priceType: string): boolean {
        return this.editModalCustomPriceTableService.priceNoteShouldBeVisible(priceType);

    }

    public isInfoIconVisible(): boolean {
        return !!this.infoIconText;
    }
}
